var x = 3;
var y = x;

/* a comment */

function inc(x) {
    return x + 1;
}

var z = inc(x);

